import {
  ADMIN_STORES_ROUTE,
  ADMIN_USERS_ROUTE,
  ADMIN_IMPORT_ROUTE,
  ADMIN_EXPIRY_DATE_CONTROL_ROUTE,
  ADMIN_SETTINGS_ROUTE
} from '../utils/Constants';

export const AdminRoutes = () => {
    const routes = [
          ADMIN_STORES_ROUTE,
          ADMIN_USERS_ROUTE,
          ADMIN_EXPIRY_DATE_CONTROL_ROUTE,
          ADMIN_IMPORT_ROUTE,
          ADMIN_SETTINGS_ROUTE,
      ]
    return routes;
  }
  